const Documents = {

    // FIELDS
    "title": "Title",
    "description": "Description",
    "status": "Status",
    "file": "File",
    "search": "Search",

    // PAGE HEADER
    "documents": "Documents",

    // ERROR
    "error_title": "Enter Title",
    "error_description": "Enter Description",
    "error_status": "Select Status",
    "error_files": "Choose File",

    // TABLE HEADER
    "table_title": 'TITLE',
    "table_description": 'DESCRIPTION',
    "table_status": "STATUS",

}

export default Documents;
